import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/AuthContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/QueryProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/Navigation.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
